function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import Vue from 'vue';
import { sync } from 'vuex-pathify';
import { VCheckbox } from 'vuetify/lib';
import template from './susvimo-section-selection.html';
import FormMixin from '../form.mixin';

var SusvimoSectionSelection = /*#__PURE__*/function () {
  function SusvimoSectionSelection() {
    _classCallCheck(this, SusvimoSectionSelection);
  }

  _createClass(SusvimoSectionSelection, null, [{
    key: "register",
    value: function register() {
      Vue.component('susvimo-section-selection', {
        template: template,
        components: {
          VCheckbox: VCheckbox
        },
        mixins: [FormMixin],
        props: {
          sections: {
            type: Array,
            "default": function _default() {
              return [];
            }
          },
          title: {
            type: String,
            "default": ''
          }
        },
        data: function data() {
          var _this = this;

          return {
            checkboxValues: [],
            customRules: {
              oneValueSelected: function oneValueSelected(selected) {
                if (!_this.bind.rules.length || _this.bind.rules[0].name !== 'required') {
                  return true;
                }

                return selected.length > 0 || _this.$root.labels.ruleRequired;
              }
            },
            error: null
          };
        },
        computed: {
          proceduralStep: sync('forms/form@proceduralStep')
        },
        watch: {
          proceduralStep: function proceduralStep(newVal) {
            if (newVal) {
              this.checkboxValues = [];
              this.updateValues();
            }
          }
        },
        methods: {
          updateValues: function updateValues() {
            this.$emit('input', this.checkboxValues);
          },
          toggleValue: function toggleValue(value) {
            if (this.checkboxValues.includes(value)) {
              this.checkboxValues = this.checkboxValues.filter(function (item) {
                return item !== value;
              });
            } else {
              this.checkboxValues.push(value);
            }

            this.$emit('input', this.checkboxValues);
          },
          updateError: function updateError(error) {
            if (error) {
              this.error = this.$root.labels.ruleRequired;
              return;
            }

            this.error = null;
          }
        }
      });
    }
  }]);

  return SusvimoSectionSelection;
}();

export default SusvimoSectionSelection;